import { Card, Heading, Stack, Text } from '../../ui';
import { landingCopy } from './copy';
import { FlagIcon, PinMark, WrenchIcon } from './icons';

/** The icon shown for each feature, keyed by the feature's stable key. */
const FEATURE_ICONS: Record<string, React.JSX.Element> = {
  garage: <WrenchIcon size={28} />,
  discover: <PinMark size={28} />,
  racing: <FlagIcon size={28} />,
};

/**
 * The three product pillars — Garage, Discover and Racing — as a responsive card grid.
 *
 * @returns The feature-highlights section.
 */
export function FeatureHighlights(): React.JSX.Element {
  return (
    <section className="gm-landing__section" aria-labelledby="gm-landing-features">
      <div className="gm-landing__section-head">
        <h2 id="gm-landing-features" className="gm-landing__section-title">
          What you can do
        </h2>
      </div>

      <div className="gm-grid">
        {landingCopy.features.map((feature) => (
          <Card key={feature.key} ariaLabel={feature.title}>
            <Stack gap="sm">
              <span className="gm-landing__feature-icon">{FEATURE_ICONS[feature.key]}</span>
              <Heading level={3}>{feature.title}</Heading>
              <Text muted>{feature.body}</Text>
            </Stack>
          </Card>
        ))}
      </div>
    </section>
  );
}
